import type { AssetTreeNode } from './types';

export const findNodeByKey = (nodes: AssetTreeNode[], key: string): AssetTreeNode | null => {
  for (const node of nodes) {
    if (node.key === key) return node;
    if (node.children) {
      const found = findNodeByKey(node.children, key);
      if (found) return found;
    }
  }
  return null;
};

export const updateNodeChildren = (
  nodes: AssetTreeNode[],
  targetKey: string,
  children: AssetTreeNode[]
): AssetTreeNode[] => {
  return nodes.map((node) => {
    if (node.key === targetKey) {
      return { ...node, children };
    }
    if (node.children && node.children.length > 0) {
      return { ...node, children: updateNodeChildren(node.children, targetKey, children) };
    }
    return node;
  });
};
